import React from 'react';
import { useRecaptcha } from '../hooks/useRecaptcha';

export interface WithRecaptchaProps {
  getToken: (action: string) => Promise<string>;
}

export const withRecaptcha = <P extends WithRecaptchaProps>(
  WrappedComponent: React.ComponentType<P>
) => {
  const WithRecaptcha = (props: Omit<P, keyof WithRecaptchaProps>) => {
    const { getToken } = useRecaptcha();
    return <WrappedComponent {...(props as P)} getToken={getToken} />;
  };

  WithRecaptcha.displayName = `withRecaptcha(${WrappedComponent.displayName || WrappedComponent.name})`;
  return WithRecaptcha;
};